












import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import UnifyButton from '@/shared/components/unify/unify-button.vue'

@Component({
  name: 'respondeco-dialog-button',
  components: { UnifyButton },
})
export default class RespondecoDialogButton extends Vue {
  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly disabled!: boolean

  @Prop({
    default: 'global-loader',
    type: [Boolean, String],
  })
  public readonly loading!: boolean | string

  public click(event: any) {
    this.$emit('click', event)
  }
}
